import React from "react";
import { Route } from "react-router-dom";
import Tabs from "../../components/Tabs";
import CustomerList from "./components/CustomerList";
import { CUSTOMER_TABS } from "./consts";

const CustomersPage: React.FC = () => {
  return (
    <Tabs
      tabs={CUSTOMER_TABS}
      activeRoute={<Route path="/" element={<CustomerList />} />}
    />
  );
};

export default CustomersPage;
